import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { ClientAddressEntity } from './client-address.entity';
import { PriceContractEntity } from './price-contract.entity';

/**
 * PD-17316 — a ship-to a job pricing contract covers. Written by the ERP
 * pricing import (Prophet 21's `job_price_customer_shipto`), which adds the
 * contract's current ship-tos and removes the ones the ERP dropped. The job
 * auto-link adds them to the ship-tos of the jobs linked to the contract
 * (`job_ship_to`); it never removes a job's ship-to.
 *
 * Prices still apply per customer (through the contract's customer group);
 * these rows only say which job sites the contract names.
 *
 * SM2-only; SM1 never reads it.
 */
@Index(
	'price_contract_ship_to__contract_address',
	['fkPriceContractId', 'fkClientAddressId'],
	{ unique: true },
)
@Index('price_contract_ship_to__fk_client_address__id', ['fkClientAddressId'], {})
@Entity('price_contract_ship_to')
export class PriceContractShipToEntity extends BaseEntity {
	@Column('int', { name: 'fk_price_contract__id', unsigned: true })
	public fkPriceContractId!: number;

	@Column('int', { name: 'fk_client_address__id', unsigned: true })
	public fkClientAddressId!: number;

	/** The ERP's id for the row (Prophet 21: `job_price_cust_shipto_uid`). */
	@Column('varchar', { name: 'externalId', nullable: true, length: 64 })
	public externalId!: string | null;

	@ManyToOne(() => PriceContractEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_price_contract__id', referencedColumnName: 'id' }])
	public priceContract!: PriceContractEntity;

	@ManyToOne(() => ClientAddressEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client_address__id', referencedColumnName: 'id' }])
	public clientAddress!: ClientAddressEntity;
}
